
export const environment = {
    production: true,
    apiUrl: '#{apiUrl}#',
    signalRurl: '#{signalRurl}#',
    sourceName: 'SARAPLUS SecureData UAT',
    tokenCredentials: '#{tokenCredentials}#',
    sessionDecryptKey: '#{sessionDecryptKey}#',
    ignoreEncryption: false,
    azureFDID: '6b3c6079-782d-4ffa-95e7-6c0f459b0083',
    sessionTimeout: '#{sessionTimeout}#',
    sessionIdle: '#{sessionIdle}#',
    appVersion: '#{buildVersion}#',
    smartyApiKey: '4149485524500617',
    smartyApiUrl: 'https://us-autocomplete-pro.api.smarty.com',
    sentryTokenUrl: '#{secureDataSentryTokenUrl}#'
}
